import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import { usePriceRowContext } from '../../../price-row-context';
import { IconChevronRight } from '@prisjakt/ui/icon/chevron-right';
import { ButtonIcon } from '@prisjakt/ui/button';
import { ButtonText } from '@prisjakt/ui/button/variants';
import { ViewSize } from '../../types';

import { StyledWrapper, StyledButton } from './styles';

export const GoToStoreButton = () => {
  const { t } = useContext(AppContext);
  const { viewSize, isOurChoice } = usePriceRowContext();

  const renderButton = () => {
    if (viewSize === ViewSize.SMALL && !isOurChoice) {
      return <IconChevronRight color="maybeBlue500" size={24} />;
    }
    return (
      <StyledButton
        ariaLabel={t('product', 'store.link')}
        tabIndex={-1}
        $viewSize={viewSize}
      >
        {viewSize >= ViewSize.MEDIUM && (
          <ButtonText>{t('product', 'store.link')}</ButtonText>
        )}
        <ButtonIcon>
          <IconChevronRight />
        </ButtonIcon>
      </StyledButton>
    );
  };

  return (
    <StyledWrapper data-test="GoToStoreButton">{renderButton()}</StyledWrapper>
  );
};
